import BlogPost from 'components/pages/Blog/BlogPost.qmee';
import { buildPage, buildStaticProps, buildRelayEnvironment } from 'utils/pageHelper';
import { GetStaticPaths } from 'next/types';
import { fetchQuery } from 'react-relay';
import { BLOG_POST_COUNT, blogPostSlugQuery } from 'components/pages/Blog/BlogPosts.qmee';
import { BlogPostsSlugQuery } from 'components/pages/Blog/__generated__/BlogPostsSlugQuery.graphql';

export default buildPage(BlogPost, {
  withNestedMetaData: true,
  skipSSR: true,
});

const MOST_POPULAR_BLOG_POSTS = [
  'reasons-you-dont-qualify-all-surveys',
  'cashing-out-to-paypal',
  'how-to-enable-qmee-on-google-chrome',
  'qmee-not-working-and-what-are-qmees-limits',
  'how-does-searching-with-qmee-work',
  'how-to-invite-friends',
  'how-to-verify-your-paypal-account-us',
  'cashing-out-to-paypal-its-not-always-instant',
  'how-to-verify-your-paypal-account-uk',
  'free-gift-cards-when-you-cash-out-with-qmee',
];

export const getStaticPaths: GetStaticPaths = async function getStaticPaths({ locales }) {
  const blogPosts = [];

  const environment = buildRelayEnvironment('en-us');

  const res = await fetchQuery<BlogPostsSlugQuery>(environment, blogPostSlugQuery, {
    count: BLOG_POST_COUNT,
  }).toPromise();

  for (const locale of locales!) {
    const mappedMostPopularPosts: any = MOST_POPULAR_BLOG_POSTS.map((post) => ({
      params: { blogPostSlug: post },
      locale,
    }));

    const mappedBlogPosts = res?.blogPosts?.edges.map((blogPost) => {
      return { params: { blogPostSlug: blogPost.node.slug }, locale };
    });

    mappedBlogPosts && blogPosts.push(...mappedMostPopularPosts, ...mappedBlogPosts);
  }

  return {
    paths: blogPosts,
    fallback: 'blocking',
  };
};

export const getStaticProps = buildStaticProps('blog', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
